<template>
  <div class="main">
    <c-panel>
      <form-cardapio :paramId="$route.params.id" v-on:onSubmitCardapio="onSubmitCardapio"></form-cardapio>
    </c-panel>
  </div>
</template>
<script>
import formCardapio from "./form"

export default {
  methods: {
    onSubmitCardapio () {
      this.$router.push('/admin/merenda/cardapio')
    }
  },
  components: { formCardapio }
}
</script>

